var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBtnEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Appointment-expand",
    transform: "translate(-965.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(225.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-edit",
    transform: "translate(720.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic-edit",
    transform: "translate(12.631579, 11.578947)",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.052632)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9.80036298,
    y1: 1.72690563,
    x2: 13.6116152,
    y2: 5.53815789,
    id: "Stroke-352"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.54446461,
    y1: 10.982804,
    x2: 4.35571688,
    y2: 14.7940563,
    id: "Stroke-353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35571688,14.7940563 L2.26251766e-13,15.3385209 L0.54446461,10.982804 L11.2083485,0.318920145 C11.6335753,-0.106306715 12.3228675,-0.106306715 12.7480944,0.318920145 L15.0196007,2.5904265 C15.4448276,3.01565336 15.4448276,3.70494555 15.0196007,4.13017241 L4.35571688,14.7940563 L4.35571688,14.7940563 Z",
    id: "Stroke-355"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnEdit);
export default __webpack_public_path__ + "static/media/icBtnEdit.32594c4bb180000495a9c3de46a1cb28.svg";
export { ForwardRef as ReactComponent };